import { SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
/**
 * Whether a Computer orchestrator can be switched on a follow-up. True only when
 * a model advertises `support_model_switching` or is the generic default
 * (`SearchModel.ASI`), which has no model-config row from which
 * `supportsModelSwitching` can derive support.
 *
 * Shared by the legacy model dropdown (resolveModelPickerControl) and the
 * submission's thread-model override (ComputerThreadContent). Computer effort
 * selections use mode_config instead and keep their selector independently of
 * the resolved model's support for legacy switching.
 *
 * For model-only selections, both call sites must pass the same `model` so the
 * dropdown and submission override agree. This helper does not reconcile
 * divergent inputs.
 */
export function canSwitchComputerModel(model, supportsModelSwitching) {
    return model === SearchModel.ASI || supportsModelSwitching(model);
}
//# sourceMappingURL=canSwitchComputerModel.js.map